import { defineStore } from 'pinia';
import { createPopulateString, parseCollectionData } from '~/utils/strapiComponents/addStrapiData';
import { strapi } from '../transport/strapi';
import type {
  INotificationSettings,
  INotificationSettingsStrapiResponse,
} from '~/types/notifications';

export const useStoreNotificationsSettings = defineStore('notificationsSettings', {
  state: () => ({
    notificationsSettings: [] as INotificationSettings[],
    requestPromise: null as Promise<INotificationSettingsStrapiResponse> | null,
  }),

  actions: {
    async loadNotificationSettings() {
      if (!this.requestPromise) {
        const populateString = createPopulateString([
          'icon',
          'bannerComplex',
          'bannerComplex.desktopAssetFront',
          'bannerComplex.desktopAssetBack',
          'bannerComplex.mobileAsset',
        ]);

        this.requestPromise = strapi()
          .get('notifications-settings', populateString)
          .finally(() => (this.requestPromise = null));
      }

      const response = await this.requestPromise;

      if (response?.data) {
        this.notificationsSettings = parseCollectionData(response.data);

        return true;
      } else {
        return false;
      }
    },
  },
});
